import React from "react";
import "./SelectedComment.css";
import { Box, Divider, Paper, Rating, Typography, IconButton, Stack, Chip } from "@mui/material";
import { formatDate } from "../../../utils/Utils";
import { FaTrash } from "react-icons/fa";

function SelectedComment({ comment, deleteComment }) {

    return (
        <Paper className="selected-comment" elevation={3}>
            <Box className="header">
                <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"baseline"}>
                    <Typography variant="h5">Commentaire de {comment.username}</Typography>
                    <Typography variant="body1">{formatDate(comment.date)}</Typography>
                </Box>
                <Typography variant="h6">Sujet: {comment.subject}</Typography>
                <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <Stack direction="row" spacing={1} marginBlock="0.25rem">
                        {comment.tags && comment.tags.map((tag, index) => (
                            <Chip key={index} label={tag} />
                        ))}
                    </Stack>
                    {comment.satisfaction_level && <Rating name="satisfaction" value={comment.satisfaction_level} readOnly />}
                </Box>
            </Box>
            <Divider />
            <Box className="content">
                <Typography align="justify" variant="body1">{comment.content}</Typography>
                {comment.media_path && <img className="image" src={comment.media_path} alt="comment" />}
            </Box>
            <Divider />
            <IconButton onClick={() => deleteComment(comment.id)}>
                <FaTrash />
            </IconButton>

        </Paper>
    );
}

export default SelectedComment;